<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: LabInfoModal.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,      -->
<!-- propagated, or distributed without prior approval by ESA.                  -->
<template>
  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Datalab Details</h5>
          <button type="button" class="asset__modal-close close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body theme-shadow">
          <p v-if="data.name">
            <span class="text-muted">Name</span>
            : {{ data.name }}
          </p>
          <p v-if="data.image">
            <span class="text-muted">Type</span>
            : {{ data.image }}
          </p>
          <p v-if="data.description">
            <span class="text-muted">Description</span>
            : {{ data.description }}
          </p>
          <!-- <p v-if="data.id">
            <span class="text-muted">Id</span>
            : {{ data.id }}
          </p>-->
          <!-- <p v-if="data['filter-list']">
            <span class="text-muted">Search</span>
            :
            <router-link
              :to="filterLink"
              @click="$emit('closeModal')"
              data-dismiss="modal"
            >{{ data['filter-list'].search }}</router-link>
          </p>-->
          <p v-if="data.creation_date">
            <span class="text-muted">Creation Date</span>
            : {{ creationDate }}
          </p>
          <p v-if="lastAccessTime">
            <span class="text-muted">Last Access Time</span>
            : {{ lastAccessTime }}
          </p>
          <!-- <p v-if="data['assets-list']">
            <span class="text-muted">Assets List</span>
            : {{ data['assets-list'] }}
          </p>-->
          <p v-if="data.status">
            <span class="text-muted">Status</span>
            :
            <em>{{ data.status }}</em>
          </p>
        </div>
        <div class="asset__modal-actions modal-footer">
          <!-- Download -->
          <!-- <button
            type="button"
            class="asset__modal-download btn btn-sm mr-2"
            @click.prevent="download"
            :class="clsOngoingDownload"
            :disabled="ongoingDownload"
          >
            <i class="icon icon-download bold-me"></i>
          </button>-->
          <!-- Open in lab -->
          <div class="d-inline-block mr-2">
            <button
              v-if="auth && isUser"
              class="asset__modal-lab btn btn-sm"
              title="Open"
              @click.prevent="$emit('openAssetLab', data)"
              data-dismiss="modal"
            >
              <i class="icon icon-play"></i>
            </button>
            <!-- Delete Button -->
            <button
              class="asset__modal-delete btn btn-sm"
              title="Delete"
              @click.prevent="$emit('deleteAssetLab', data)"
              data-dismiss="modal"
            >
              <i class="icon icon-delete"></i>
            </button>
            <!-- Edit Button -->
            <button
              class="asset__modal-edit btn btn-sm"
              title="Edit"
              @click.prevent="$emit('editAssetLab', data)"
              data-dismiss="modal"
            >
              <i class="icon icon-edit"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helpers from '@/lib/helpers'

export default {
  props: {
    data: Object,
    value: Boolean,
  },
  computed: {
    auth() {
      return this.$store.getters.isAuthenticated
    },
    isUser() {
      return this.$store.getters.isUser
    },
    filterLink() {
      let query = {}
      let search = this.data['filter-list'].search
      if (search && search !== 'None') {
        if (typeof search == 'object') {
          query = helpers.objectFromArrayOfObjectsHandleDuplicates(search)
        } else if (typeof search == 'string') {
          query = helpers.objectFromArrayOfObjectsHandleDuplicates(JSON.parse(search.replace(/'/gi, '"')))
        }
        query.mode = query.coord ? 'map' : 'query'
      }
      return {
        name: 'assets',
        query,
      }
    },
    creationDate() {
      const date = new Date(this.data['creation_date'])
      // show only date
      return date.toISOString().slice(0, 10)
    },
    lastAccessTime() {
      const dateUTC = new Date(this.data['last_access_time'] + 'Z')
      // show date and time
      // return `${dateUTC.toISOString().slice(0, 10)} ${dateUTC.toISOString().slice(11, 19)}`
      var year = dateUTC.toLocaleString('default', { year: 'numeric' })
      var month = dateUTC.toLocaleString('default', { month: '2-digit' })
      var day = dateUTC.toLocaleString('default', { day: '2-digit' })
      var hour = dateUTC.toLocaleString('default', { hour: '2-digit' })
      var minutes = dateUTC.toLocaleString('default', { minute: '2-digit' })
      var seconds = dateUTC.toLocaleString('default', { second: '2-digit' })

      return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '~@/styles/globals';

.modal .modal-dialog .modal-content {
  border: none;
  border-radius: $border-radius;

  .modal-header {
    border-radius: $border-radius $border-radius 0 0;
    background: $neutral-space;
  }

  .modal-body {
    border: none;
  }

  .modal-footer {
    border-radius: 0 0 $border-radius $border-radius;
    border: none;
    background-color: $primary;
    align-items: flex-start;

    button {
      color: $white-ghost;

      &:hover {
        color: $main;
      }
    }
  }
}

.asset__modal-actions {
  display: flex;

  .icon {
    padding: 0;
  }
}

.asset__modal-group {
  h4 {
    font-size: 1.3rem !important;
    font-weight: bold !important;
    color: $black-85 !important;
  }
}

.asset__modal-close {
  position: absolute;
  right: 1rem;
  top: 1rem;
  // background-color: green;
  border-radius: 0.3rem;
  opacity: 1;

  span {
    opacity: 0.8;
    color: $deep-space;
  }

  &:hover {
    opacity: 1 !important;

    span {
      color: $deep-space;
      opacity: 1;
    }
  }
}
</style>
